/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: links.ts
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const Common: Record<string, string> = {
  UNKNOWN: '*'
};

const Public: Record<string, string> = {
  HOME: '/',
  ABOUT_US: '/#about-us',
  SERVICES: '/#services',
  PROJECTS: '/projects',
  CONTACT_US: '/contact-us',
  CAREERS: '/careers'
};

const Links = {
  Common,
  Public
};

export default Links;
